import React, { useState } from "react";
import { ConfigProvider, DatePicker } from "antd";
import dayjs from "dayjs";
import { GlobalStyles } from "@mui/material";

const globalStyles = {
    ".single-datetime-popup": { zIndex: "1500 !important" },
    ".ant-picker-dropdown": { zIndex: "1500 !important" },
};

// Backend format for timeline / metrics-preview timestamps.
const OUTPUT_FORMAT = "YYYY-MM-DD HH:mm:ss";

// Single date + time picker (calendar + HH/MM + Now/Ok). Controlled by a
// string value in OUTPUT_FORMAT; emits the same string (or null when cleared).
const SingleDateTimePicker = ({
    value = null,
    onChange = () => {},
    placeholder = "Select date and time",
    hasError = false,
    disabled = false,
    minDate = null,
    maxDate = null,
    // Optional Cypress handle, matching SingleDatePicker. Off by default so no
    // existing caller changes.
    dataTestId = undefined,
    // The control's height. Defaulted to what it has always been, so the
    // RecordReplacement timeline is untouched; the work order form passes the
    // one height every field on that page shares.
    height = "42px",
    // antd's accent, used by the PORTALED popup -- the selected day, the
    // Now/OK buttons, the time column highlight. Nothing in a parent's sx can
    // reach those, so the only way to recolour them is through the token.
    //
    // Defaulted to what it has always been, so RecordReplacement is untouched.
    colorPrimary = "#4F44E0",
}) => {
    const [open, setOpen] = useState(false);

    const selected = value ? dayjs(value, OUTPUT_FORMAT) : null;
    const min = minDate ? dayjs(minDate) : null;
    const max = maxDate ? dayjs(maxDate) : null;

    const disabledDate = (current) => {
        if (!current) return false;
        if (min && current.isBefore(min, "day")) return true;
        if (max && current.isAfter(max, "day")) return true;
        return false;
    };

    return (
        <ConfigProvider theme={{ token: { colorPrimary } }}>
            <GlobalStyles styles={globalStyles} />
            <DatePicker
                data-testid={dataTestId}
                popupClassName="single-datetime-popup"
                value={selected}
                onChange={(date) => onChange(date ? date.format(OUTPUT_FORMAT) : null)}
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD hh:mm A"
                placeholder={placeholder}
                disabled={disabled}
                status={hasError ? "error" : ""}
                inputReadOnly
                allowClear={false}
                disabledDate={disabledDate}
                onOpenChange={setOpen}
                open={open}
                style={{
                    width: "100%",
                    height,
                    borderRadius: "8px",
                }}
            />
        </ConfigProvider>
    );
};

export default SingleDateTimePicker;
